import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml', standalone: true })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private readonly sanitized: DomSanitizer) {}

  transform(value: string): SafeHtml {
    const replaced = value?.replaceAll('&nbsp;', ' ');
    return this.sanitized.bypassSecurityTrustHtml(replaced); //NOSONAR
  }
}
